var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('delete-confirmation',{attrs:{"visible":_vm.HasAccess('account.delete'),"allowed-to-delete":_vm.HasAccess('account.delete'),"action":_vm.remove,"confirmation-text":_vm.$t('screens.accounts.confirmation.delete')}})}
var staticRenderFns = []

export { render, staticRenderFns }